export default {
  edit_note: 'Rediger note',
  add_note: 'Tilføj note ',
  update: 'Opdater vare',
  feedback: {
    item_sold_out_one: 'Vi beklager, men vi er desværre udsolgt af {{items}}.',
    item_sold_out_other: 'Vi beklager, men vi er desværre udsolgt af {{items}}.',
    item_unavailable:
      'Denne vare kan kun bestilles fra {{schedule}}. Skift tidspunktet for bestillingen, eller fjern varen for at bestille.',
  },
  buttons: {
    update: 'Opdater',
  },
};
